import { Alert, Button, Spin } from "@arco-design/web-react";
import { QrCode } from "lucide-react";
import { useItineraryTable } from "../runtime/useItineraryTable";
import { itineraryPreviewLoadErrorText } from "../runtime/itineraryPreviewRuntime";
import { ItineraryShareQrModal } from "./ItineraryShareQrModal";
import { ItineraryTableDocument } from "./ItineraryTableDocument";
import "./itineraryEditor.css";

/** 独立数据库表格页面，沿用预览分享权限与二维码卡片。 */
export function ItineraryTableFeaturePage({ itineraryId, canShare }: { itineraryId: string; canShare: boolean }) {
  const runtime = useItineraryTable(itineraryId);
  const { query } = runtime;
  return <main className="itinerary-table-page">
    {query.isPending || query.isFetching ? <div className="itinerary-table-page-state"><Spin block tip="正在加载行程表格" /></div>
      : query.isError ? <Alert type="error" content={itineraryPreviewLoadErrorText(query.error)} action={<Button onClick={() => void query.refetch()}>重试</Button>} />
      : <ItineraryTableDocument itinerary={query.data} actions={canShare ? <Button icon={<QrCode size={16} />} loading={runtime.sharing} disabled={runtime.sharing} onClick={() => void runtime.share()}>分享</Button> : undefined} />}
    {runtime.error && <Alert type="error" content={runtime.error} />}
    <ItineraryShareQrModal visible={Boolean(runtime.shareUrl)} shareUrl={runtime.shareUrl} onClose={runtime.closeShare} />
  </main>;
}
